<template>
<div>

	<div class="row">
		<div class="col-xl-4">
			<p style="line-height:40px;"><b>Total:</b> {{ totalSpent | toHoursMinutes }}</p>
		</div>
		<div class="col-xl-8">
			<div class="date-select">
				<button @click="backWeek" type="button" class="btn me-2">
					<i class="fa fa-chevron-left"></i>
				</button>

				<span class="date">
					{{ weekStarting.format('DD/MM') }} - {{ weekEnding.format('DD/MM') }}
					<span class="year">{{ weekEnding.format('YYYY') }}</span>
				</span>

				<button @click="forwardWeek" type="button" class="btn ms-2">
					<i class="fa fa-chevron-right"></i>
				</button>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="offset-xl-3 col-xl-9">

			<div class="timesheet-overview">

				<div class="date">
					<div class="row">
						<div v-for="index in range" class="col" v-bind:key="index">
							{{ weekStarting.clone().add(index-1, 'd').format('D') }}
						</div>
					</div><!-- /,row -->
				</div><!-- /.date -->

				<div class="backing">

					<div class="week-day">
						<div class="row">
							<div v-for="index in range" class="col" v-bind:key="index">
								{{ weekStarting.clone().add(index-1, 'd').format('ddd') }}
							</div>
						</div><!-- /,row -->
					</div><!-- /.week-day -->

					<div v-if="fetching == false" class="daily-total">
						<div class="row">
              <div
                v-for="index in range"
                class="col"
                :class="{
                  muted: calculateTimeSpent(weekStarting.clone().add(index-1, 'd')) === 0
                }"
                v-bind:key="index"
              >
								{{ calculateTimeSpent(weekStarting.clone().add(index-1, 'd')) | toHoursMinutes }}
							</div>
						</div><!-- /,row -->
					</div><!-- /.daily-total -->

				</div><!-- /.backing -->

			</div><!-- /.timesheet-overview -->

		</div>
	</div><!-- /.row -->

    <ul class="timesheet-breakdown" v-if="fetching == false">
		<li v-for="(company, key) in companies" :key="key">
			<div class="row">
				<div class="col-xl-3">
					<p class="client-heading truncate" :title="key">
						{{ key }}
						<button type="button" class="btn collapsed" data-toggle="collapse" :data-target="`#collapse-${company[0].project_id}`">
							<i class="fa fa-chevron-down"></i>
						</button>
					</p>
				</div>
				<div class="col-xl-9">

					<div class="entries">
						<div class="row">
							<div
                v-for="index in range"
                class="col"
                :class="{
                  muted: calculateTimeSpent(weekStarting.clone().add(index-1, 'd'), company[0].project_id) === 0
                }"
                v-bind:key="index"
              >
								{{ calculateTimeSpent(weekStarting.clone().add(index-1, 'd'), company[0].project_id) | toHoursMinutes }}
							</div>
						</div><!-- /,row -->
					</div><!-- /.entries -->

				</div>
			</div><!-- /.row -->

			<div class="collapse" :id="`collapse-${company[0].project_id}`">

				<div v-for="timeEntry in company" :key="timeEntry.id" class="row row-entry">
					<div class="col-xl-3">
						<p :title="timeEntry.title" class="entry-heading truncate">
							{{ timeEntry.title }}
						</p>
					</div>
					<div class="col-xl-9">

						<div class="entries">
							<div class="row">
								<div
                  v-for="index in range"
                  class="col"
                  :class="{
                    muted: calculateTimeSpent(weekStarting.clone().add(index-1, 'd'), timeEntry.project_id, timeEntry.id) === 0
                  }"
                  v-bind:key="index"
                >
									{{ calculateTimeSpent(weekStarting.clone().add(index-1, 'd'), timeEntry.project_id, timeEntry.id) | toHoursMinutes }}
								</div>
							</div><!-- /,row -->
						</div><!-- /.entries -->

					</div>
				</div><!-- /.row-entry -->

			</div><!-- collapse -->

		</li>
    </ul>
</div><!-- /.wrapper -->
</template>

<script>

    import { mapState, mapActions } from 'vuex'
    import {user, appliesFilters} from 'mixins'
    import { groupBy, filter, sumBy, debounce } from 'lodash'

    export default {
        mixins: [user, appliesFilters],

        data: function () {
            return {
				filters: {
					week: moment().startOf('isoWeek').format('DD-MM-YYYY'),
				},
				filtersDebounced: false,
				fetching: false,
				getTimesheetDebounce: debounce(function () {
					this.handleGetTimesheets()
				}, 500)
            }
        },

        created() {
            this.handleGetTimesheets()
		},

		watch: {
			queryParams: {
				async handler (params) {

					this.fetching = true
					await this.getTimesheetDebounce()
				},
				immediate: true
			}
		},


        computed: {
            ...mapState('user', ['user', 'authorized', 'timesheet']),

            range() {
                return 7
			},

			weekStarting () {
				return moment(this.filters.week, "DD-MM-YYYY")
			},

            weekEnding() {
                return this.weekStarting.clone().add(6, 'd')
            },

            companies() {
                return groupBy(this.timesheet, (item) => {
                    return item.project_name
                })
			},

			totalSpent() {
				return sumBy(this.timesheet, 'spent')
			}
        },

        methods: {
            ...mapActions('user', ['getUserTimesheet']),

            backWeek() {
				this.filters.week = this.weekStarting.clone().subtract(7, 'd').format('DD-MM-YYYY')
            },

            forwardWeek() {
                this.filters.week = this.weekStarting.clone().add(7, 'd').format('DD-MM-YYYY')
            },

            async handleGetTimesheets() {
                this.fetching = true
                await this.getUserTimesheet({
                    id: this.$route.params.id,
                    payload: {
                        start: this.weekStarting.format('DD-MM-YYYY'),
                        end: this.weekEnding.format('DD-MM-YYYY')
                    }
                })
                this.fetching = false
            },

            calculateTimeSpent(date, clientId, timeEntryId) {
                var dateSpecificEntries =  filter(this.timesheet, (item) => {
                    return moment(item.entry_date).isSame(date, 'day')
                })

                if (clientId) {
                    dateSpecificEntries = filter(dateSpecificEntries, (item) => {
                        return item.project_id === clientId
                    })
                }

                if (timeEntryId) {
                    dateSpecificEntries = filter(dateSpecificEntries, (item) => {
                        return item.id === timeEntryId
                    })
                }

                return sumBy(dateSpecificEntries, 'spent')
            }
        }
    }
</script>
